import React from 'react';
export function HistorySection() {
  return <section data-id="element-4128">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-4129">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4130">
          EDM - A Brief History
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-4131">
        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-4132">
          <div className="space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-4133">
            <p data-id="element-4134">
              The origin of electrical discharge machining goes back to 1770,
              when English scientist Joseph Priestly discovered the erosive
              effect of electrical discharges. In 1943, Soviet scientists B.
              Lazarenko and N. Lazarenko had the idea of exploiting the
              destructive effect of an electrical discharge and developing a
              controlled process for machining materials that are conductors of
              electricity. With that idea, the EDM process was born.
            </p>
            <p data-id="element-4135">
              The Lazarenkos perfected the electrical discharge process, which
              consisted of a succession of discharges made to take place between
              two conductors separated from each other by a film of
              nonconducting liquid, called a dielectric. The Lazarenkos achieved
              a form of immortality with this circuit, which today bears their
              name. Today, many EDMs use an advanced version of the Lazarenko
              circuit.
            </p>
            <p data-id="element-4136">
              In 1952, the manufacturer Charmilles, became interested in spark
              erosion machining, created the first machine using this machining
              process was presented for the first time at the European Machine
              Tool Exhibition in Milan in 1955.
            </p>
            <p data-id="element-4137">
              Numerical control and feedback loops with ultra fast servos were
              added in the 1970's.
            </p>
            <p data-id="element-4138">
              Today, full 3-D CAD/CAMS feed the controls of the machines with
              code generated to control path and spark characteristics.
            </p>
            <div className="pt-6 text-center" data-id="element-4139">
              <a href="https://www.peakedm.com/preview/uploaded/files/History%20of%20AgieCharmilles%20-%20EDM.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-block bg-orange hover:bg-orange/90 text-white font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-4140">
                History of AgieCharmilles EDM
              </a>
            </div>
          </div>

          <div className="space-y-10" data-id="element-4141">
            <div className="text-center space-y-4" data-id="element-4142">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Wire/Lazarenko.jpg" alt="Lazarenko" className="block mx-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4143" />
              <p className="text-sm text-gray-600 italic max-w-sm mx-auto" data-id="element-4144">
                Back in 1952 Mr. and Mrs. Lazarenko shown here meeting with Jean
                Pfau-Physicist at Charmilles who heads up a team of engineers to
                create a machine that will use the erosive effects of electrical
                discharges to cut metals.
              </p>
            </div>
            <div className="text-center space-y-4" data-id="element-4145">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/preview/uploaded/images/Wire/Jean%20Pfau.jpg" alt="Jean Pfau" className="block mx-auto rounded-lg shadow-sm border border-gray-200" data-id="element-4146" />
              <p className="text-sm text-gray-600 italic max-w-sm mx-auto" data-id="element-4147">
                Mr. Jean Pfau the "Father of EDM" at Charmilles. (photo taken in
                2002)
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}